<div class="image-container">
    <img src="assets/img/vendor-dashboard.svg" alt="vendor dashboard" class="w-100" loading="lazy">
</div>